/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS9 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_8;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_9;
    },
    getDownloadName() {
      return ns.IOS9.nice_name;
    },
  });

  Object.assign(IOS9, {
    slug: `ios_9`,
    nice_name: `iOS 9 adoption`,
    description: `How quickly are consumers upgrading to iOS 9?`,
  });
  ns.IOS9 = IOS9;
});

}.call(window));